import { useCallback, useEffect, useState } from "react";
import { currentUsage, messageFromError } from "../../utils/api";

export default function useUsage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setError("");
    try {
      setData(await currentUsage());
    } catch (requestError) {
      setError(messageFromError(requestError, "Usage and plan details could not be loaded."));
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  return { data, error, load };
}

